
import {FC} from 'react';
import {
  Table,
  TableContainer as MuiTableContainer,
  TableBody as MuiTableBody,
  TableCell as MuiTableCell,
  TableHead as MuiTableHead,
  TableRow as MuiTableRow,
} from "@material-ui/core";
import styled from "styled-components/macro";
const TableContainer = styled(MuiTableContainer)`
  &::-webkit-scrollbar {
    width: 10px;
    position: absolute;
  }

  &::-webkit-scrollbar-thumb {
    background: #aaaaaabf;
    border-radius: 10px;
    border: 3px solid #233145;
  }
  &::-webkit-scrollbar-corner { 
    display: none;
  }
`
const TableRow = styled(MuiTableRow)`
    &:last-child th,
    &:last-child td {
        border-bottom: 0;
        border-top: 0;
    }
  `;
const TableHead = styled(MuiTableHead)`
    background: #202D40;
    box-shadow: inset 0px -0.808585px 0px rgba(224, 224, 224, 0.25);
    th {
        height: 42px
    }
    th:last-child { 
        text-align: right
    }
`;
const TableBody = styled(MuiTableBody)`
th, td {
    height: 51px
}
td:last-child { 
    text-align: right;
    white-space: nowrap;
}
`;
const TableCell = styled(MuiTableCell)`
    padding-top: 0;
    padding-bottom: 0;
    border-bottom: 0;
`;

type PropsType = {
  headNames?: Array<string>,
  rows: Array<object>
  height?: number,
}
const TableStats:FC<PropsType> = ({headNames = [], rows, height = 93}) => {

  const tableHeadNames = () => {
    if (headNames.length > 0) {
      return headNames.map((name, index) => {
        return <TableCell key={index}>{name}</TableCell>
      })
    }
    return <></>
  }
  const tableRows = () => {
    return rows.map((row, rowIndex) => {
      return <TableRow key={rowIndex}>
        {Object.values(row).map((value, cellIndex) => {
          return <TableCell key={cellIndex}>{value}</TableCell>
        })}
      </TableRow>

    })
  }
  return (
    <TableContainer style={{height: height + 'px'}}>
      <Table>
        <TableHead>
          <TableRow>
            {tableHeadNames()}
          </TableRow>
        </TableHead>
        <TableBody>
          {tableRows()}
        </TableBody>
      </Table>
    </TableContainer>
  )
}
export default TableStats
